export enum FileFormatEnum {
    ALLOWED = ".pdf,application/pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/png,image/jpeg",
    IMAGE_ONLY = "image/png,image/jpeg"
}